<template>
  <section class="find-us">
    <div class="container">
      <div class="row mb-4 mx-2">
        <img class="top-img" src="@/assets/svg/Ardunic Elements-24.svg" />
        <div class="title ml-4">
          <h2>Find</h2>
          <h2>Ardunic</h2>
        </div>
      </div>
      <div class="card-wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
            <div
              v-if="chosenSpace != null"
              class="map-responsive"
              v-html="chosenSpace.googleMap"
            >
              <!-- <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3335.081566525087!2d44.41314406542777!3d33.29052901924849!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x155781ccb814da51%3A0xbe18de6a079b1460!2z2KfYsdiv2YjZhtmDINmD2LHYp9iv2Kk!5e0!3m2!1sar!2siq!4v1571418738530!5m2!1sar!2siq"
                width="720"
                height="400"
                frameborder="0"
                style="border:0;
                    border-radius: 25px"
                allowfullscreen
              ></iframe>-->
            </div>
            <div v-if="chosenSpace == null" class="map-responsive">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3335.081566525087!2d44.41314406542777!3d33.29052901924849!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x155781ccb814da51%3A0xbe18de6a079b1460!2z2KfYsdiv2YjZhtmDINmD2LHYp9iv2Kk!5e0!3m2!1sar!2siq!4v1571418738530!5m2!1sar!2siq"
                width="720"
                height="400"
                frameborder="0"
                style="border: 0; border-radius: 25px"
                allowfullscreen
              ></iframe>
            </div>

            <!-- <img src="https://www.opf.org.pk/wp-content/uploads/2019/04/Gujrat-720x400.jpg" alt /> -->
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <ul class="stores">
              <li
                v-for="space in spaces"
                v-bind:key="space._id"
                class="store"
                @click="chosenSpace = space"
                style="cursor: pointer"
              >
                <div
                  class="info-wrap"
                  :class="{
                    active: chosenSpace._id == space._id ? true : false,
                  }"
                >
                  <div class="info">
                    <h5>{{ space.title }}</h5>
                    <!-- <span>30 KM</span> -->
                  </div>
                  <p class="info-p">{{ space.phone }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data: () => {
    return {
      spaces: [],
      chosenSpace: null,
    };
  },
  created() {
    this.getSpaces();
  },
  methods: {
    getSpaces() {
      axios
        .get(`https://api.ardunic.com/v1/spaces`)
        .then(
          (res) => (
            (this.spaces = res.data.data), (this.chosenSpace = res.data.data[0])
          )
        );
    },
  },
};
</script>

<style scoped>
.stores {
  list-style: none;
}

.stores.store .info {
  display: flex;
  justify-content: space-between;
}

.stores.store .info span {
  font-weight: 700;
}

.info-wrap {
  padding-left: 10px;
}

.active {
  border-left: 6px solid #0370d6;
}

.map-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.map-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
li {
  border-bottom: 2px solid #acacac;
  margin-bottom: 20px;
}

li:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.info-p {
  color: gray;
}

h5 {
  margin: 0;
  font-weight: 500;
}
.find-us {
  margin-top: 90px;
}

.title h2 {
  font-weight: normal;
  line-height: 0.8;
}

.card-wrapper {
  padding: 20px;
  border: 1px solid #2a2a2a;
  border-radius: 20px;
}

.title {
  padding-top: 20px;
}

.top-img {
  width: 40px;
}
</style>
